import { render, staticRenderFns } from "./client-field-show.html?vue&type=template&id=78a92652&scoped=true&"
import script from "./client-field-show.js?vue&type=script&lang=js&"
export * from "./client-field-show.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a92652",
  null
  
)

export default component.exports